export enum VerificationSchemaView {
  General = "general",
  ScreeningServices = "screening_services",
  AdditionalQuestions = "Additional Questions",
  TenantQualifications = "terms_and_conditions",
  SubmissionDisclosure = "submission_disclosure",
  DecisionCriteria = "Decision criteria",
  LeadSource = "lead_source",
  PersonalDetails = "personal_details",
  Dependents = "dependents",
  EmergencyContacts = "emergency_contacts",
  Pets = "pets",
  Vehicles = "vehicles",
  MilitaryFirstResponderTeacher = "military_first_responder_teacher",
  BasicInformation = "rental_application",
  IdentityVerification = "identity_verification",
  IdentityRiskSignal = "identity_risk_signal",
  IncomeHistory = "verified_income_verification",
  CombinedIncomeVerification = "combined_income_verification",
  HousingHistory = "housing_history",
  RentalVerification = "rental_verification",
  CreditReport = "credit_report",
  CriminalReport = "criminal_report",
  HousingCourtReport = "eviction_report",
  // Verified Income
  DocumentVerification = "document_verification",
  BankVerification = "bank_verification",
  PayrollVerification = "payroll_verification",
  // Income
  Employment = "employment",
  SelfEmployed = "self_employed",
  OfferLetter = "offer_letter",
  OtherIncome = "other_income",
  HousingAssistance = "housing_assistance",
  // Combined Income
  CombinedEmployment = "combined_employment",
  CombinedSelfEmployed = "combined_self_employed",
  CombinedOfferLetter = "combined_offer_letter",
  CombinedOtherIncome = "combined_other_income",
  CombinedHousingAssistance = "combined_housing_assistance",
  // Housing history (free)
  HousingHistoryRent = "rent",
  HousingHistoryOwn = "own_home",
  HousingHistoryOther = "other",
  HousingHistoryGeneralConfiguration = "general_housing_configuration",
  // Housing history (or rental) verification
  RentalVerificationSelfAttested = "rental_verification_self_attested",
  RentalVerificationRent = "rental_verification_rent",
  RentalVerificationOwn = "rental_verification_own_home",
  RentalVerificationOther = "rental_verification_other",
  RentalVerificationSelfAttestedConfiguration = "rental_verification_general_housing_configuration",
  RentalVerificationConfiguration = "rental_verification_configuration",
  RentalVerificationPlan = "rental_verification_plan",
  RentalVerificationSurvey = "rental_verification_survey",
  //
  CountyWalkIn = "county_walk_in",
  CountyWalkInAutomatic = "county_walk_in_automatic",
  CountyWalkInManual = "county_walk_in_manual",
  AdverseAction = "adverse_action",
  AdverseActionGenericTemplate = "adverse_action_template",
  AdverseActionWATemplate = "adverse_action_wa_template",
  DiscountCodes = "discount_codes",
  PetScreeningReport = "pet_screening_report",
  PetScreeningEmailPreferences = "pet_screening_email_preferences",
  PetPolicy = "pet_policy",
  AdditionalFees = "additional_fees",
  // BoomFinance (Loan application)
  BoomFinanceVerification = "boom_finance_verification",
  BoomFinanceLoanDetails = "boom_finance_loan_details",
  BoomFinanceHomeDetails = "boom_finance_home_details",
  BoomFinanceBusinessState = "boom_finance_business_state",
  BoomFinanceIntendedUse = "boom_finance_intended_use",
  BoomFinanceDemographics = "boom_finance_demographics",
  BoomFinanceIncomeHistory = "boom_finance_income_history",
  BoomFinanceHousingHistory = "boom_finance_housing_history",
  BoomFinanceDeclarations = "boom_finance_declarations",
  BoomFinanceConsents = "boom_finance_consents"
}
